import { useState, useEffect } from "react";
import { Container, Card, Form, Button, Alert, Spinner, ListGroup } from "react-bootstrap";
import { useCallback } from "react";

export default function TestMarketplace() {
  const [price, setPrice] = useState("");
  const [loading, setLoading] = useState(false);
  const [daysForSale, setDaysForSale] = useState([]);
  const [myDays, setMyDays] = useState([]);
  const [message, setMessage] = useState("");
  const [selectedDayId, setSelectedDayId] = useState("");

  const token = localStorage.getItem("token");



const fetchDaysForSale = useCallback(async () => {
  try {
    const res = await fetch("/api/days/selling", {
      headers: { Authorization: `Bearer ${token}` },
    });
    if (!res.ok) {
      throw new Error("Failed to fetch days for sale");
    }
    const data = await res.json();
    setDaysForSale(data);
  } catch (err) {
    setMessage(err.message || "Failed to load marketplace");
  }
}, [token]);

const fetchMyDays = useCallback(async () => {
  try {
    if (!token) return;
    const res = await fetch("/api/days/registry", {
      headers: { Authorization: `Bearer ${token}` },
    });
    if (!res.ok) {
      throw new Error("Failed to fetch your days");
    }
    const data = await res.json();
    const userId = JSON.parse(atob(token.split(".")[1])).id;
    setMyDays(data.filter((d) => d.owner._id === userId));
  } catch (err) {
    setMessage(err.message || "Failed to load your days");
  }
}, [token]);
  useEffect(() => {
    fetchDaysForSale();
    fetchMyDays();
  }, [fetchDaysForSale, fetchMyDays]);

  // Simulate selling a day
  const handleSell = async () => {
    if (!selectedDayId) {
      setMessage("Select a day first");
      return;
    }
    if (!price) {
      setMessage("Enter a price first");
      return;
    }
    setLoading(true);
    setMessage("");
    try {
      const res = await fetch("/api/days/sell", {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
        body: JSON.stringify({ dayId: selectedDayId, price: Math.round(parseFloat(price) * 100) }),
      });
      const data = await res.json();
      if (res.ok) {
        setMessage(`Day ${data.date} listed for sale at $${data.price / 100}`);
        setPrice("");
        setSelectedDayId("");
        fetchDaysForSale();
        fetchMyDays();
      } else {
        setMessage(data.message || "Failed to list day for sale");
      }
    } catch (err) {
      setMessage(err.message || "Failed to list day for sale");
    }
    setLoading(false);
  };

  // Simulate buying a day
  const handleBuy = async (day) => {
    setLoading(true);
    setMessage("");
    try {
      // Mock payment by immediately confirming
      const res = await fetch("/api/days/marketplace/purchase", {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
        body: JSON.stringify({ dayId: day._id, paymentIntentId: "mock-test-id" }),
      });
      const data = await res.json();
      if (res.ok) {
        setMessage(`Successfully purchased ${data.date}`);
        fetchDaysForSale();
        fetchMyDays();
      } else {
        setMessage(data.message || "Failed to purchase day");
      }
    } catch (err) {
      setMessage(err.message || "Failed to purchase day");
    }
    setLoading(false);
  };

  return (
    <Container className="mt-5" style={{ maxWidth: 700 }}>
      <Card className="shadow-sm mb-4">
        <Card.Body>
          <Card.Title>🛒 Sell a Day</Card.Title>
          {message && <Alert variant="info">{message}</Alert>}
          <Form className="d-flex gap-2">
<Form.Select
  value={selectedDayId} // create a new state for selected day id
  onChange={(e) => setSelectedDayId(e.target.value)}
>
  <option value="">Select one of your days</option>
  {myDays.map((d) => (
    <option key={d._id} value={d._id}>
      {d.date} {d.forSale ? "(Already for sale)" : ""}
    </option>
  ))}
</Form.Select>

            <Form.Control
              type="number"
              placeholder="Price ($)"
              value={price}
              onChange={(e) => setPrice(e.target.value)}
            />
            <Button disabled={!selectedDayId || !price || loading} onClick={handleSell}>
              {loading ? <Spinner size="sm" /> : "List for Sale"}
            </Button>
          </Form>
        </Card.Body>
      </Card>

      <Card className="shadow-sm mb-4">
        <Card.Body>
          <Card.Title>🛍️ Buy a Day</Card.Title>
          <ListGroup>
            {daysForSale.length === 0 && <ListGroup.Item>No days for sale</ListGroup.Item>}
            {daysForSale.map((day) => (
              <ListGroup.Item
                key={day._id}
                className="d-flex justify-content-between align-items-center"
              >
                <span>{day.date} - ${day.price / 100} by {day.owner.email}</span>
                <Button size="sm" onClick={() => handleBuy(day)} disabled={loading}>
                  {loading ? <Spinner size="sm" /> : "Buy"}
                </Button>
              </ListGroup.Item>
            ))}
          </ListGroup>
        </Card.Body>
      </Card>
    </Container>
  );
}
